import { useMutation } from "@tanstack/react-query";
import { deviceApis } from "../../../../../../shared/apis/device/apis";

export function useExcelMutation() {
  const { mutate: uploadExcel } = useMutation(deviceApis.shipment.postBulkDispatchDevices);

  return { uploadExcel };
}
